export default __webpack_public_path__ + "static/media/firstfoundation.4887c2ec.png";